import {
	IVervAPIServices,
	PaypalConfigData,
	StripeConfigData,
	WebCatalogProductResponse,
	Status,
	BiDataRequest,
	IUserData,
} from './VervAPITypes';

export const InMemoryCached = (service: IVervAPIServices): IVervAPIServices => {
	let paypalConfigCache: PaypalConfigData | undefined;
	let stripeConfigCache: StripeConfigData | undefined;
	const productsCache = new Map<string, WebCatalogProductResponse>();

	return {
		location: service.location,

		async getPaypalConfig() {
			if (paypalConfigCache != null) return paypalConfigCache;

			const data = await service.getPaypalConfig();
			if (data.status === Status.success) {
				paypalConfigCache = data;
			}
			return data;
		},

		async ping() {
			return await service.ping();
		},

		async registerPaypalSubscription(dataToSend) {
			return await service.registerPaypalSubscription(dataToSend);
		},

		async getStripeConfig() {
			if (stripeConfigCache != null) return stripeConfigCache;

			const data = await service.getStripeConfig();
			if (data.status === Status.success) {
				stripeConfigCache = data;
			}
			return data;
		},

		async sendUserData(data: IUserData) {
			const result = await service.sendUserData(data);
			return result;
		},

		async sendBiData(event: BiDataRequest) {
			return await service.sendBiData(event);
		},

		async createStripeSubscription(dataToSend) {
			return await service.createStripeSubscription(dataToSend);
		},

		async changeStripeSubscription(data) {
			return await service.changeStripeSubscription(data);
		},

		async purchaseProduct(data) {
			return await service.purchaseProduct(data);
		},

		async createPaypalOrder(data) {
			return await service.createPaypalOrder(data);
		},

		async registerPaypalOrder(data) {
			return await service.registerPaypalOrder(data);
		},

		async intentStripePayment(paymentIntentId) {
			return await service.intentStripePayment(paymentIntentId);
		},

		async getWebCatalogProduct(productName) {
			const cachedProduct = productsCache.get(productName);
			if (cachedProduct != null) return cachedProduct;

			const data = await service.getWebCatalogProduct(productName);

			if (data.status === Status.success) {
				productsCache.set(productName, data);
			}
			return data;
		},
	};
};
